// create a context for the manage team attendance modal
import React, { createContext, useContext, useState } from 'react'

export interface ManageTeamAttendanceModalContextType {
  selectedTeamName: string | null
  setSelectedTeamName: (teamName: string | null) => void
  selectedTeamId: string | null
  setSelectedTeamId: (teamId: string | null) => void
  selectedTeamRosterId: string | null
  setSelectedTeamRosterId: (teamRosterId: string | null) => void
  onSubmit: () => void
}

export const ManageTeamAttendanceModalContext = createContext<
  ManageTeamAttendanceModalContextType | undefined
>(undefined)

export const useManageTeamAttendanceModalContext = () => {
  const context = useContext(ManageTeamAttendanceModalContext)
  if (!context) {
    throw new Error(
      'useManageTeamAttendanceModalContext must be used within a ManageTeamAttendanceModalProvider'
    )
  }
  return context
}

export const ManageTeamAttendanceModalProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [selectedTeamName, setSelectedTeamName] = useState<string | null>(null)
  const [selectedTeamId, setSelectedTeamId] = useState<string | null>(null)
  const [selectedTeamRosterId, setSelectedTeamRosterId] = useState<any>(null)

  const onSubmit = () => {
    console.log('onSubmit')
  }

  return (
    <ManageTeamAttendanceModalContext.Provider
      value={{
        selectedTeamName,
        setSelectedTeamName,
        selectedTeamId,
        setSelectedTeamId,
        selectedTeamRosterId,
        setSelectedTeamRosterId,
        onSubmit,
      }}
    >
      {children}
    </ManageTeamAttendanceModalContext.Provider>
  )
}
